module.exports = __webpack_public_path__ + "assets/icons/no-dealer-icon-c4b8.png";